import { BaseService } from '../../infra/base.service'
import type { Log } from './log.entity'
import { LogAction } from './log.entity'
import type { LogsRepository } from './logs.repository'

export class LogsService extends BaseService<Log> {
    constructor(private rep: LogsRepository) {
        super(rep)
    }

    // trilha de estornos do período. o eixo é a data do evento, não o vencimento da parcela.
    async getRefunds(from: Date, to: Date): Promise<Log[]> {
        return await this.rep.getAll({ from, to, type: LogAction.charge_refunded })
    }
}
